import Event from '../../../../utils/event';
import {SYSTEM_EVENTS} from '../../../../events/events';
import BaseRegulation, { IAccountData } from '../base_regulation';
import { REGULATION_STATUS_ID_MAP } from '../../regulation_const';

export default class NetherlandsRegulation extends BaseRegulation {
    static CLASS = 'NetherlandsRegulation';



    /**
     *
     * @param params
     */
     init(params) {
        super.init(params);
    }

    private _getAccountData(): IAccountData {
        return this.serviceFactory.userService().getAccountData() as IAccountData;
    }

    isAnonymousPlayAllowed() : boolean {
        if(!this.serviceFactory.oAuth2Service().isAuthorized()) {
            return false;
        }

        return this._getAccountData().RegulationStatusId === REGULATION_STATUS_ID_MAP.APPROVED_FOR_REGULATION;
    }


    shouldShowPlayerLimitsToaster(): boolean {
        return true;
    }

    _sendAnalytics(action, value) {
        Event.fire(SYSTEM_EVENTS.ANALYTIC_TRIGGER_ACTIVATED, {
            category: 'Regulation',
            action: action,
            label: 'Netherlands',
            value: value
        });
    }

    sessionTimerEnabled() {
        return true;
    }

    sessionTimerVisible() {
        return true;
    }

    showResponsibleIcons() {
        return true;
    }

    showAgeResponsibleIconInGame() {
        return true;
    }

    showAgeResponsibleGameInDetailedHistory() {
        return true;
    }

    getAgeResponsibleGamingLabel() {
        return this.serviceFactory.languageService().translation('responsible_gaming_age_label');
    }
}
